import React, { FC } from 'react';
import { AddEntityWatcherButton } from '../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../components/modal/components/modal-restricted/withRestrictedModal';

const source = 'enterprise_snippet';

type Props = {
  enterpriseId: string;
  raisonSociale: string;
} & WithRestrictedModalProps;

export const RawEntepriseFollowButton: FC<Props> = ({
  openRestrictedModal,
  raisonSociale,
  enterpriseId,
}) => {
  const showRestrictedModal = () => {
    openRestrictedModal('want_to_follow_enterprise');
  };
  return (
    <AddEntityWatcherButton
      queryParams={{ eid: enterpriseId, q: raisonSociale }}
      uniqueId={enterpriseId}
      restrict={showRestrictedModal}
      source={source}
      secondary
    />
  );
};

export const EntepriseFollowButton = withRestrictedModal(
  RawEntepriseFollowButton,
);
